<template>
  <div class="startpage-quicklink">
    <div
      v-for="(item, index) in items"
      :key="item.contentId"
      class="startpage-quicklink__item"
      @click="simulateClickOnLink(index)"
      @keypress.enter="simulateClickOnLink(index)"
    >
      <div
        class="startpage-quicklink__image-wrapper"
      >
        <epi-property
          id="Image"
          text="Bild"
        />
        <epi-picture
          :image="item.image"
          :sizes="dimensions"
          :use-picture="true"
          :auto-aspect-ratio="false"
        />
      </div>
      <div class="startpage-quicklink__content-wrapper">
        <h3
          v-if="item.buttonLabel"
          class="startpage-quicklink__heading"
        >
          <a
            ref="startPageQuickLink"
            v-edit="'Url'"
            :href="item.url"
            @click.stop="trackClick(item.buttonLabel, item.url)"
          >{{ item.buttonLabel }}</a>
        </h3>
        <p
          v-if="item.preamble"
          class="startpage-quicklink__preamble"
        >
          {{ item.preamble }}
        </p>
      </div>
      <epi-property
        id="ButtonLabel"
        text="Knapptext"
      />
      <epi-property
        id="Url"
        text="Knapplänk"
      />
    </div>
  </div>
</template>
<script>
import dataLayer from '@/analytics/dataLayer'

export default {
  name: 'StartPageQuickLinks',
  components: {},
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      dimensions: {
        small: {
          height: 80,
          width: 80
        },
        medium: {
          height: 116,
          width: 116
        },
        large: {
          height: 116,
          width: 116
        }
      },
    }
  },
  methods: {
    simulateClickOnLink (index) {
      this.$refs.startPageQuickLink[index].click()
    },
    trackClick (text, url) {
      dataLayer.add({
        event: 'promoSelect',
        linkName: text,
        linkUrl: !/^https?:\/\//i.test(url) ? window.location.origin + url : url,
      })
    }
  }
}
</script>
<style lang="scss">
.startpage-quicklink {
  @include media-breakpoint-up (md) {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    margin-top: -3.75rem;
    box-shadow: $box-shadow-primary;
    margin-bottom: 3rem;
    padding: 0;
    margin-left: -1.5rem;
    margin-right: -1.5rem;
    background-color: $color-white;
  }

  @include media-breakpoint-up (xl) {
    margin-left: 0;
    margin-right: 0;
    border-radius: 0 0 2rem 2rem;
  }

  &__item {
    display: grid;
    grid-template-columns: 5rem 1fr;
    grid-template-rows: 1fr;
    grid-column-gap: 1rem;
    padding: 1rem 1.5rem;
    border-top: 1px solid $color-grey-special;
    background-color: $color-white;

    @include media-breakpoint-up (md) {
      grid-template-columns: 1fr;
      grid-template-rows: 7.75rem 1fr;
      justify-items: center;
      grid-row-gap: 1rem;
      padding: 0 1rem 2.625rem;
      border-top: 0;
      border-right: 1px solid $color-grey-special;
      background-color: transparent;
    }

    @include media-breakpoint-up (xl) {
      padding: 0 3rem 2.625rem;
    }

    &:last-child {
      border-radius: 0 0 2rem 2rem;
      margin-bottom: 2rem;
      box-shadow: $box-shadow-primary;

      @include media-breakpoint-up (md) {
        border-radius: 0;
        margin-bottom: 0;
        box-shadow: none;
        border-right: 0;
      }
    }
  }

  &--noHero {
    @include media-breakpoint-down (sm) {
      margin-top: -2rem;

      .startpage-quicklink__item:first-child {
        border-radius: 0.25rem 0.25rem 0 0;
      }
    }
  }

  &__content-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;

    @include media-breakpoint-up (md) {
      text-align: center;
      justify-content: flex-start;
    }
  }

  &__heading {
    @include font(rubrik, 2, "bold");

    margin: 0;

    @include media-breakpoint-up (md) {
      margin-bottom: 0.25rem;
    }
  }

  &__preamble {
    @include font(text, 2, "normal");

    letter-spacing: 0;
    margin: 0;

    @include media-breakpoint-up (md) {
      @include font(text, 3, "normal");
    }
  }

  &__image-wrapper picture {
    @include media-breakpoint-up (md) {
      width: 7.75rem;
      border: 0.25rem solid $color-white;
      background-color: $color-white;
    }

    border-radius: 50%;
    overflow: hidden;
  }
}

</style>

